// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.6604 6.42257V17.5773L12.0001 23.1546L2.33984 17.5773V6.42257L12.0001 0.845215L21.6604 6.42257ZM12 10.7982L8.72268 8.61328L7.61328 10.2774L11 12.5352V16H13V12.5352L16.3868 10.2774L15.2774 8.61328L12 10.7982Z"}}]};

const ApplicationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'application-filled',
    ref,
    icon: element,
  },
));

ApplicationFilledIcon.displayName = 'ApplicationFilledIcon';

export default ApplicationFilledIcon;
